export function returnDescricaoInsumo(insumo_, isCliente = false) {
    if (insumo_ && insumo_.insumo) {
        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = insumo.id_insumo + " Descrição Principal: " + insumo.descricao;

        // 🔥 VARIAÇÕES – permanece igual
        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes
                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                ))
                .join('');
        }
        
        if (isCliente) {
            return textoComQuebraDeLinha;
        }

        // 🔥 COTAÇÕES – AGORA MUITO MAIS LIMPO
        if (insumo.cotacoes && insumo.cotacoes.length > 0) {
            const cotacoesOrdenadas = insumo.cotacoes;

            const formatarValor = (valor) =>
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

            const formatarData = (data) =>
                new Date(data).toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });

            const ultimasTres = cotacoesOrdenadas.slice(-3);

            textoComQuebraDeLinha += ultimasTres
                .map((cotacao) => {
                    return `<br />*Cotação -> ${formatarValor(cotacao.valor_unitario)} em ${formatarData(cotacao.data)}`;
                })
                .join('');

            const soma = cotacoesOrdenadas.reduce((acc, c) => acc + c.valor_unitario, 0);
            const media = soma / cotacoesOrdenadas.length;

            textoComQuebraDeLinha += `<br />Valor médio: ${formatarValor(media)}`;

            const ultimaCotacao = cotacoesOrdenadas[cotacoesOrdenadas.length - 1];
            textoComQuebraDeLinha += `<br />Última Cotação: ${formatarValor(ultimaCotacao.valor_unitario)} em ${formatarData(ultimaCotacao.data)}`;

        } else {
            textoComQuebraDeLinha += `<br />Sem cotações`;
        }

        let quantidadeDisponivel = 0;
        let textoEstoque = "";

        if (Array.isArray(insumo_.itens_estoque)) {
            const itensDisponiveis = insumo_.itens_estoque.filter(item => item.status_item === 0);
            quantidadeDisponivel = itensDisponiveis.length;

            // 🔥 NOVO: Agrupa por armazenamento
            const quantidadePorArmazenamento = itensDisponiveis.reduce((acc, item) => {
                const armazenamentoKey = item.id_armazenamento && item.id_armazenamento !== 0
                    ? item.descricao_armazenamento
                    : "INDEFINIDO";

                if (!acc[armazenamentoKey]) {
                    acc[armazenamentoKey] = 0;
                }
                acc[armazenamentoKey]++;
                return acc;
            }, {});

            // Formata o texto do estoque
            if (Object.keys(quantidadePorArmazenamento).length > 0) {
                textoEstoque = Object.entries(quantidadePorArmazenamento)
                    .map(([local, quantidade]) => `${quantidade} em ${local}`)
                    .join(', ');
            } else {
                textoEstoque = "0 unidades";
            }
        }

        return textoComQuebraDeLinha + "<br />Estoque: " + quantidadeDisponivel + " unidades (" + textoEstoque + ")";
    }
}

